export const getStepForInputByMinMax = (min: number, max: number) => {
  const range = Math.abs(max - min)
  if (range === 0) return 0.01
  let step = range / 100

  const magnitude = 10 ** Math.floor(Math.log10(step))

  step /= magnitude
  if (step > 5) {
    step = 10
  } else if (step > 2) {
    step = 5
  } else if (step > 1) {
    step = 2
  } else {
    step = 1
  }
  return step * magnitude
}
